var React = require('react');

function IconHamburger (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_1566","data-name":"Group 1566","transform":"translate(0 0.75)"},[React.createElement("line",{"id":"Line_30","data-name":"Line 30","x2":"32.172","fill":"none","stroke":"#fff","strokeWidth":"1.5","key":0}),React.createElement("line",{"id":"Line_31","data-name":"Line 31","x2":"32.172","transform":"translate(0 5.362)","fill":"none","stroke":"#fff","strokeWidth":"1.5","key":1}),React.createElement("line",{"id":"Line_32","data-name":"Line 32","x2":"32.172","transform":"translate(0 10.724)","fill":"none","stroke":"#fff","strokeWidth":"1.5","key":2})]));
}

IconHamburger.defaultProps = {"width":"32.172","height":"12.224","viewBox":"0 0 32.172 12.224"};

module.exports = IconHamburger;

IconHamburger.default = IconHamburger;
